import { createTheme } from '@mui/system';

const theme = createTheme({
  typography: {
    fontFamily: ['"Lato"', 'sans-serif'].join(','),
  },
});

export default theme;
